export default "__VITE_ASSET__29dea8f3__"